export interface LabelValue<T> {
  label: string;
  value: T;
}
export interface AutoCompleteLabelValue extends LabelValue<string> {
  label: string;
  value: string;
  //
  __bfx_visibility_type: string;
}

export function AutoCompleteLabelValueCompareFn(
  this: null,
  a: AutoCompleteLabelValue,
  b: AutoCompleteLabelValue,
) {
  return a.label.toLowerCase() < b.label.toLowerCase()
    ? -1
    : a.label.toLowerCase() > b.label.toLowerCase()
    ? 1
    : 0;
}
